package com.nonopn.skydome.common.app.home

import com.nonopn.skydome.common.app.api.impl.ApiInterface
import com.nonopn.skydome.common.app.checkout.CheckoutReturnPhase
import com.nonopn.skydome.common.app.detection.ThunderDetection
import com.nonopn.skydome.common.app.save.SavedAuthentication
import com.nonopn.skywatcher.common.api.ApiProvider
import com.nonopn.skywatcher.design.appbar.AppBarState
import com.nonopn.skywatcher.design.appbar.AppBarUiState
import com.nonopn.skywatcher.design.appbar.FloatingActionButtonState
import com.nonopn.skydome.common.app.utils.getSystemLanguage
import eu.codlab.navigation.RouteParameterTo

data class AppModelState(
    var defaultRoute: RouteParameterTo,
    var currentRoute: RouteParameterTo,
    var initialized: Boolean = false,
    var loading: Boolean = false,
    val isSystemDarkMode: Boolean,
    override val appBarState: AppBarState = AppBarState.Regular(),
    override val floatingActionButtonState: FloatingActionButtonState? = null,
    val showPromptNewDeck: Boolean = false,
    val showPromptNewScenario: Boolean = false,
    val authentication: SavedAuthentication? = null,
    val requestForGoogleAuthenticationState: String? = null,
    val thunderDetections: List<ThunderDetection> = emptyList(),
    val apiProvider: ApiProvider<ApiInterface>? = null,
    val currentApi: ApiInterface? = null,
    val appLanguage: String = getSystemLanguage(),
    // True while an admin account uses the administrator mode (admin menu + admin API)
    val isAdminMode: Boolean = false,
    // Banner after the return from the Stripe Checkout (null = no banner)
    val checkoutReturn: CheckoutReturnPhase? = null,
) : AppBarUiState
